// extracted by mini-css-extract-plugin
module.exports = {"generateButton":"css_generateButton__F_ACH","bottom":"css_bottom__3JbIA","link":"css_link__DWx2M"};